exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-inputsearch-style__inputSearch{display:flex!important;flex:1;width:303px;height:41px;justify-content:center;align-items:center;padding:9px 12px;gap:6px;border:.75px solid #adbdcc;border-radius:4px}.nil-sa-elements-inputsearch-style__inputSearch input[type=text]{width:100%;height:100%;border:none;background-color:#fff;font-family:Lato;font-size:12px;font-style:normal;font-weight:600;line-height:normal;letter-spacing:.036px;color:#29323b}.nil-sa-elements-inputsearch-style__inputSearch img{filter:invert(55%) sepia(14%) saturate(592%) hue-rotate(168deg) brightness(92%) contrast(88%)}", ""]);

// exports
exports.locals = {
	"inputSearch": "nil-sa-elements-inputsearch-style__inputSearch"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/InputSearch/style.less
// module id = 475
// module chunks = 0